export default __webpack_public_path__ + "static/address-footer-7e4c5f213a53e519a45ae79f46619ede.svg";